import { ApprovalStatus } from 'ui-product-approvals-common';
import type { ApprovalSkipStrategy } from 'ui-product-approvals-common';

export interface GetSkipInput {
  approvalStatus: ApprovalStatus | undefined;
  hasApprovalData: boolean;
  isSuperAdmin: boolean;
  skipApprovalOption: ApprovalSkipStrategy | undefined;
  usersIdsListThatCanSkipApproval: number[] | undefined;
  currentUserId: number | undefined;
}

export const getUserCanSkip = ({
  approvalStatus,
  hasApprovalData,
  isSuperAdmin,
  skipApprovalOption,
  usersIdsListThatCanSkipApproval,
  currentUserId,
}: GetSkipInput): boolean => {
  if (
    hasApprovalData &&
    (approvalStatus === ApprovalStatus.APPROVAL_PENDING ||
      approvalStatus === ApprovalStatus.CHANGES_REQUESTED)
  ) {
    return false;
  }
  if (isSuperAdmin) {
    return true;
  }

  if (skipApprovalOption) {
    switch (skipApprovalOption) {
      case 'EVERYONE_CAN_SKIP_APPROVAL':
        return true;
      case 'SPECIFIC_LIST_CAN_SKIP_APPROVAL':
        return currentUserId !== undefined
          ? usersIdsListThatCanSkipApproval?.includes(currentUserId) ?? false
          : false;
      case 'NO_ONE_CAN_SKIP_APPROVAL':
      default:
        return false;
    }
  }

  return false;
};
